import {
  ExternalLinkIcon,
  type ExternalLinkIconProps
} from "@/molecules/ExternalLinkIcon"

import styles from "./ExternalLinkMenuItem.module.scss"

export const ExternalLinkMenuItem = (props: ExternalLinkIconProps) => (
  <ExternalLinkIcon wrap className={styles.container} {...props} />
)
